<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    placehoder="Alege status"
    required
  ></v-select>
</template>

<script>
import VSelect from "@/components/VSelect.vue";
import ordersApi from "../../api/resources/ordersApi";

export default {
  props: {
    selectName: String,
    selectId: String,
    modelValue: [String, Number],
    orderId: [String, Number],
  },
  emits: ["update:modelValue"],
  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  methods: {
    getOptions() {
      ordersApi.transitionsIndex(this.orderId).then((response) => {
        this.options = response.data.map((status) => {
          return { text: status.label, value: status.id };
        });
      });
    },
  },

  mounted() {
    this.getOptions();
  },
};
</script>

<style></style>
